import markets_raw from './markets.autogen';

const markets = markets_raw.map(m => {
	return {
		...m,
		AllExchanges: [...(m.StockExchanges||[]), ...(m.IndexExchanges||[]), ...(m.ForexExchanges||[])],
	};
});

const exchange_market_map = (() => {
	const map = {};
	for (const market of markets) {
		for (const exchange of market.AllExchanges) {
			map[exchange] = market;
		}
	}
	return map;
})();

const exchanges2markets = (exchanges) => {
	let seen_markets = {};
	let markets = [];
	for (const exchange of exchanges) {
		const market = exchange_market_map[exchange];
		const id = market.Id;
		if (seen_markets[id]) continue;
		markets.push(market);
		seen_markets[id] = true;
	}
	return markets;
};

const market_ids = markets.map(x => x.Id);

const ordered_and_available_market_ids = (() => {
	// TODO FIXME duplicated in src/base/site.go
	const rest = ["COMMODITIES", "FOREX", "CRYPTOCURRENCIES", "ETFS", "INDEXES", "FUNDS"];
	if (IS_AKTIEDYSTEN_DK) {
		return ["DK_STOCK", "US_STOCK", "DE_STOCK", "SE_STOCK", "FI_STOCK", "AT_STOCK", "IS_STOCK", ...rest];
	} else if (IS_AKTIEKAMPEN_SE) {
		return ["SE_STOCK", "US_STOCK", "DE_STOCK", "DK_STOCK", "FI_STOCK", "AT_STOCK", "IS_STOCK", ...rest];
	} else if (IS_INVESTSPIEL_DE) {
		return ["DE_STOCK", "US_STOCK", "DK_STOCK", "SE_STOCK", "FI_STOCK", "AT_STOCK", "IS_STOCK", ...rest];
	} else if (IS_TRADERR_COM) {
		return ["US_STOCK", ...rest];
	} else {
		return [];
	}

})();

const market_order_key_map = (() => {
	let m = {};
	for (let i = 0; i < ordered_and_available_market_ids.length; i++) {
		m[ordered_and_available_market_ids[i]] = i;
	}
	return m;
})();

const available_markets_set = (() => {
	let m = {};
	for (let i = 0; i < ordered_and_available_market_ids.length; i++) {
		m[ordered_and_available_market_ids[i]] = true;
	}
	return m;
})();

const sort_market_ids = (xs) => {
	return xs.sort((a,b) => (market_order_key_map[a]||0) - (market_order_key_map[b]||0));
};

export {
	markets,
	market_ids,
	exchanges2markets,
	ordered_and_available_market_ids,
	available_markets_set,
	market_order_key_map,
	sort_market_ids,
}



// WEBPACK FOOTER //
// ./src/markets.js